import { observeVideos } from '@theme/lazy-video';

{
  var items = document.querySelectorAll('.reel-carousel__item');
  observeVideos(document.querySelectorAll('.reel-carousel__video'));

  // Tap-to-reveal product overlay on touch devices (hover already handles desktop via CSS).
  items.forEach(function (item) {
    var overlay = item.querySelector('.reel-carousel__product-overlay');
    if (!overlay) return;

    item.addEventListener('click', function (e) {
      if (e.target.closest('.reel-carousel__product-overlay') || e.target.closest('.reel-mute-toggle')) {
        return;
      }
      overlay.classList.toggle('is-visible');
    });

    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  // Size selection.
  document.querySelectorAll('.reel-carousel__size-selector').forEach(function (selector) {
    var buttons = selector.querySelectorAll('.reel-carousel__size-option');
    var input = selector.closest('.reel-carousel__product-overlay').querySelector('.reel-carousel__variant-input');

    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        if (button.disabled) return;
        buttons.forEach(function (b) {
          b.classList.remove('is-selected');
        });
        button.classList.add('is-selected');
        if (input) input.value = button.dataset.variantId;
      });
    });
  });

  // Add to cart.
  document.querySelectorAll('.reel-carousel__add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('.reel-carousel__add-button');
      var originalText = button.textContent;

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          button.textContent = 'Added';
          setTimeout(function () {
            button.textContent = originalText;
          }, 2000);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          button.textContent = 'Error';
          setTimeout(function () {
            button.textContent = originalText;
          }, 2000);
        });
    });
  });
}
